export default {
  Error_NotFound: "ОШИБКА: Не найден",
  Toast_DefaultError: "Ошибка: Что-то пошло не так!",
  Toast_Unauthorized: "Нет прав доступа: свяжитесь с нами",
  Toast_Logout: "Выход из личного кабинета",
  Toast_Login: "Войдите в свой аккаунт",
  Toast_Register: "Зарегистрируйтесь, чтобы получить доступ к курсам",
  Toast_ResetPassword:
    "Email на смену пароля отправлен: пройдите по ссылке из письма",
  Toast_Form_Submitted: "Форма успешно отправлена.",
  Toast_Form_Updated: "Форма успешно обновлена",
  Toast_Form_Deleted: "Форма успешно удалена",
  Toast_Form_MissingFields: "Введите обязательные поля",
  Toast_UserDropSubscription:
    "Оформление подписки отменено. Повторите попытку ещё раз или напишите нам.",
  Toast_ServerIssue: "Проблемы с соединением",
  Toast_Auth_: "Проблемы с соединением",
  Toast_Auth_UserNotFound:
    "С таким Email у нас нет пользователя. Скорее всего вы еще не регистрировались у нас. Перейдите по кнопке Регистрация",
  Toast_Auth_WrongPassword: "Неправильный пароль",
  Toast_Auth_EmailExists:
    "Вы уже зарегистрированы у нас. Войдите в свой кабинет по кнопке вход",
  Loading: "Загрузка страницы...",
  PageTitle_Home: "Главная",
  PageTitle_Course: "Курс",
  PageTitle_Schedule: "Расписание тренировок и пробные тренировки",
  PageTitle_Messengers: "Связь с нами через мессенджеры",
  PageTitle_HelpCenter: "",
  PageTitle_Events: "Управление Занятиями",
  PageTitle_AddEvent: "Добавить Занятие",
  PageTitle_EditEvent: "Редактировать Занятие",
  PageTitle_Courses: "Управление Курсами",
  PageTitle_AddCourse: "Добавить Курс",
  PageTitle_EditCourse: "Редактировать Курс",
  PageTitle_Payments: "Управление Платежами",
  PageTitle_AddPayment: "Добавить Платеж",
  PageTitle_EditPayment: "Редактировать Платеж",
  PageTitle_Promocodes: "Управление Промокодами",
  PageTitle_AddPromocode: "Добавить Промокод",
  PageTitle_EditPromocode: "Редактировать Промокод",
  PageTitle_Forms: "Управление Формами",
  SidebarLink_Home: "Главная",
  SidebarLink_Schedule: "Расписание",
  SidebarLink_Chatbots: "Мессенджеры",
  SidebarLink_HelpCenter: "Инструкции",
  SidebarTitle_ContactUs: "Связаться с нами",
  SidebarLink_Email: "info@facestudio.online",
  SidebarLink_Phone: "",
  SidebarTitle_Employee: "Менеджер",
  SidebarLink_Events: "Занятия",
  SidebarLink_Courses: "Курсы",
  SidebarLink_Payments: "Платежи",
  SidebarLink_Promocodes: "Промокоды",
  SidebarLink_Forms: "Формы",
  Button_Add: "Добавить",
  Button_Next: "Продолжить",
  Button_Delete: "Удалить",
  Button_Send: "Отправить",
  Button_Book: "Записаться",
  Button_Apply: "Применить",
  Button_Select: "Выбрать",
  Button_Publish: "Опубликовать",
  Button_Subscribe: "Оформить подписку",
  Button_FreeEvent: "Забрать бесплатное занятие",
  Button_OpenZoom: "Подключиться к тренировке вживую",
  Button_LeaveReview: "Оставить отзыв о тренировке",
  Button_ScheduleEmpty: "Выбрать курс",
  Question_Delete: "Вы уверены, что хотите удалить файл?",
  Question_NewUser: "Новый пользователь?",
  Question_ExistingUser: "У вас уже есть аккаунт?",
  Question_ForgotPassword: "Забыли пароль?",
  Link_Fold: "Свернуть",
  Link_Unfold: "Читать дальше...",
  Link_Login: "Войти",
  Link_Register: "Зарегистрироваться",
  Link_RecoverPassword: "Восстановить",
  Link_MessengersEmpty: "support@facestudio.online",
  InputLabel_EnterName: "Имя",
  InputError_EmptyName: "Необходимо ввести имя",
  InputLabel_EnterEmail: "Email",
  InputError_EmptyEmail: "Необходимо ввести email",
  InputError_EmailNotExists:
    "Пользователь с таким Email не существует. Войдите в свой личный кабинет",
  InputError_NotEmail: "Введите корректный email",
  InputLabel_EnterPassword: "Пароль",
  InputError_EmptyPassword: "Необходимо ввести пароль",
  InputError_PasswordLength: "Пароль должен быть от",
  InputError_PasswordSymbols: "символов",
  InputLabel_EnterPhone: "Номер телефона",
  InputError_EmptyPhone: "Необходимо ввести номер телефона",
  InputLabel_EnterStartDate: "Дата начала",
  InputLabel_EnterEndDate: "Дата окончания",
  InputLabel_EnterPaymentDate: "Дата платежа",
  InputError_EmptyDate: "Необходимо указать дату",
  InputLabel_EnterStartTime: "Время начала",
  InputLabel_EnterPaymentTime: "Время платежа",
  InputError_EmptyTime: "Необходимо указать время",
  InputLabel_EnterMessage: "Ваше сообщение",
  InputError_EmptyMessage: "Необходимо написать сообщение",
  InputLabel_EnterDuration: "Продолжительность",
  InputError_EmptyDuration: "Необходимо указать продолжительность",
  InputLabel_EnterDiscount: "Скидка",
  InputError_EmptyDiscount: "Необходимо указать скидку",
  InputLabel_EnterPromocode: "Введите промокод",
  InputLabel_EnterPromocodeName: "Название промокода",
  InputError_EmptyPromocode: "Необходимо ввести промокод",
  InputError_InvalidPromocode: "Данный промокод не существует",
  InputLabel_EnterYouTubeURL: "YouTube ссылка",
  InputError_EmptyYouTubeURL: "Необходима ссылка на видео в YouTube",
  InputLabel_EnterZoomURL: "Zoom ссылка",
  InputError_EmptyZoomURL: "Необходима ссылка на комнату в Zoom",
  InputLabel_EnterTrainer: "Имя тренера",
  InputError_EmptyTrainer: "Необходимо ввести имя тренера",
  InputLabel_EnterUserEmail: "Email клиента",
  InputLabel_EnterCost: "Стоимость",
  InputError_EmptyCost: "Необходимо указать стоимость",
  InputLabel_EnterEvent: "Название занятия",
  InputLabel_EnterCourse: "Название курса",
  InputLabel_EmptyName: "Необходимо ввести название",
  InputLabel_EnterDesc: "Описание занятия",
  InputLabel_EmptyDesc: "Необходимо написать описание",
  InputLabel_EnterLeelooAiTag: "Тэг ID из LeelooAi",
  InputLabel_SelectCourse: "Выберете курс",
  InputError_EmptyCourse: "Необходимо выбрать курс",
  InputLabel_SelectEventType: "Тип занятия",
  ToSAgreement: "Нажимая на кнопку, вы соглашаетесь с",
  ToS: "условиями",
  GreetingMessage: "Добро пожаловать!",
  WelcomeMessage:
    "Для того, чтобы попробовать занятие бесплатно, выберите курс (например, Экспресс), нажмите Выбрать. После этого вы увидите расписание тренировок, а также кнопку Бесплатное занятие, с помощью которой вы запишитесь на бесплатное занятие!Есои у вас уже есть абонемент, просмотрите свою программу тренировок во вкладке расписание.",
  Title_ScheduleEmpty: "Расписания пока нет",
  Subtitle_ScheduleEmpty: "Сперва добавьте тренировки",
  Title_MessengersEmpty: "Свяжитесь с нами",
  Subtitle_MessengersEmpty:
    "Что-то пошло не так, \n приносим прощение за неудобства",
  SectionTitle_Forms:
    "У вас есть возможность вступить в закрытое сообщество в Телеграм с участницами студии и тренером",
  SectionTitle_Courses: "Выберете, чем вы хотите заниматься",
  CardTitle_Login: "Вход",
  CardSubtitle_Login:
    "Зарегистрируйтесь, если вы у нас впервые. После регистрации вы попадете на страницу расписания на этой неделе и сможете выбрать ту тренировку, которая вам понравится!",
  CardTitle_Register: "Регистрация",
  CardSubtitle_Register:
    "Зарегистрируйтесь, чтобы получить бесплатную тренировку в личном кабинете. После регистрации вы попадете на страницу расписания на этой неделе и сможете выбрать ту тренировку, которая вам понравится, а также приобрести абонемент на занятия.",
  CardTitle_RecoverPassword: "Восстановление пароля",
  CardTitle_JoinTelegram: "Сообщество в Телеграм",
  CardDesc_JoinTelegram:
    "Все участницы студии имеют доступ к закрытому сообществу в Телеграм. <br />Пожалуйста, укажите номер телефона, к которому привязан ваш Телеграм в форме ниже. <br />Добавим вас <i>в течение 24 часов</i>.",
  CardTitle_FormPsychologist: "Психолог",
  CardDesc_FormPsychologist:
    "Мы понимаем, что за красоту лица, в том числе отвечает ваш внутренний покой. <br />В нашей команде работает замечательная психолог Ольга Пережогина, которой вы можете задать свой вопрос совершенно анонимно. <br />Ольга делится ответами на ваши вопросы в Телеграм чате.",
  CardTitle_FormNumerologist: "Нумеролог",
  CardDesc_FormNumerologist:
    "Мы заботимся о благополучии вашего внутреннего мира, поэтому в нашей команде работает замечательный нумеролог. <br />Задайте свой вопрос анонимно, и мы поделимся ответом в Телеграм чате FaceStudio.",
  SectionTitle_AllEvents: "Все занятия",
  SectionTitle_AllCourses: "Все курсы",
  SectionTitle_AllPayments: "Все платежи",
  SectionTitle_AllPromocodes: "Все промокоды",
  SectionTitle_AllForms: "Все формы",
  SectionTitle_Event: "Занятие",
  SectionTitle_Course: "Курс",
  SectionTitle_Payment: "Платеж",
  SectionTitle_Promocode: "Промокод",
  SectionTitle_Form: "Форма",
  Author: "Автор",
  Published: "Опубликовано",
  Editor: "Редактор",
  LastEdit: "Последняя редакция",
  Today: "Сегодня",
  Recording: "Запись",
  Conference: "Конференция",
  Preview: "Анонс",
  CloudPayments: "CloudPayments",
  Manual: "Ручная",
  Soon: "Скоро",
  Done: "Прошло",
  InProgress: "Идёт",
  Promocode: "Промокод",
  Course: "Курс",
  Actions: "Действия",
  UserID: "ID Пользователя",
  Client: "Клиент",
  Trainer: "Тренер",
  Title: "Название",
  Desc: "Описание",
  Type: "Тип",
  Date: "Дата",
  Sum: "Сумма",
  Cost: "Цена",
  Code: "Код",
  Period: "Период",
  Discount: "Скидка",
  Status: "Статус",
  Used: "Активирован",
  UsedBy: "Активировали",
  Currency: "руб",
  Mon: "мес",
  Min: "мин"
};
